import SettingsGear from 'app/common/components/Settings'

import { dataKey } from './useWarehouseStockSettings'

export type DishesTableSettings = {
  rows: number
}

export const WarehouseStockGear = () => {
  return <SettingsGear dataKey={dataKey}>{({ saveSettings }) => <div></div>}</SettingsGear>
}
